import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { initPWATracking, registerServiceWorker } from "./utils/pwaTracking";

// Import pages
import Home from "./pages/Home";
import WhatIsFokatmain from "./pages/WhatIsFokatmain";
import About from "./pages/About";
import WinnersGallery from "./pages/WinnersGallery";
import UploadWinner from "./pages/UploadWinner";
import BrandCollaboration from "./pages/BrandCollaboration";
import Partnership from "./pages/Partnership";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Contact from "./pages/Contact";
import Careers from "./pages/Careers";
import PlayGames from "./pages/PlayGames";
import Auth from "./pages/Auth";
import FAQ from "./pages/FAQ";
import RefundPolicy from "./pages/RefundPolicy";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import PlayerDashboard from "./pages/PlayerDashboard";
import PublicLeaderboard from "./pages/PublicLeaderboard";
import GamingPolicy from "./pages/GamingPolicy";
import Instagram from "./pages/Instagram";
import InstagramBio from "./pages/InstagramBio";

// Import components
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import WelcomeSplash from "./components/WelcomeSplash";
import CompetitionLiveModal from "./components/CompetitionLiveModal";

function App() {
  const [showWelcomeSplash, setShowWelcomeSplash] = useState(false);
  const [userName, setUserName] = useState(null);

  useEffect(() => {
    // Register service worker for PWA
    registerServiceWorker();
    
    // Initialize PWA install tracking
    initPWATracking();

    // Check if app is running as PWA (standalone mode)
    const isPWA = window.matchMedia('(display-mode: standalone)').matches || 
                  window.navigator.standalone === true;

    // Check if welcome splash should be shown (only for PWA and if not shown today)
    const lastShown = localStorage.getItem('welcome_splash_shown');
    const today = new Date().toDateString();
    
    if (isPWA && lastShown !== today) {
      // Get user info if logged in
      const userStr = localStorage.getItem('fokatmain_user');
      if (userStr) {
        try {
          const user = JSON.parse(userStr);
          setUserName(user.username || user.email?.split('@')[0]);
        } catch (e) {
          console.error('Error parsing user:', e);
        }
      }
      
      setShowWelcomeSplash(true);
    }
  }, []);

  const handleContinueFromSplash = () => {
    setShowWelcomeSplash(false);
    // Mark splash as shown today
    localStorage.setItem('welcome_splash_shown', new Date().toDateString());
  };

  return (
    <div className="App">
      {/* Welcome Splash Screen for PWA */}
      {showWelcomeSplash && (
        <WelcomeSplash 
          onContinue={handleContinueFromSplash}
          userName={userName}
        />
      )}
      
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/what-is-fokatmain" element={<WhatIsFokatmain />} />
            <Route path="/about" element={<About />} />
            <Route path="/brands" element={<BrandCollaboration />} />
            <Route path="/partnership" element={<Partnership />} />
            <Route path="/play-games" element={<PlayGames />} />
            <Route path="/login" element={<Auth initialMode="login" />} />
            <Route path="/signup" element={<Auth initialMode="signup" />} />
            <Route path="/dashboard" element={<PlayerDashboard />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/leaderboard" element={<PublicLeaderboard />} />
            <Route path="/gaming-policy" element={<GamingPolicy />} />
            <Route path="/winners" element={<WinnersGallery />} />
            <Route path="/admin/upload-winner" element={<UploadWinner />} />
            <Route path="/instagram" element={<Instagram />} />
            <Route path="/bio" element={<InstagramBio />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
        {/* Competition Live Notification Modal */}
        <CompetitionLiveModal />
      </BrowserRouter>
    </div>
  );
}

export default App;